export const CUSTOMER_TYPE_FILTER_KEY = 'customer_type';
export const PAYMENT_STATUS_FILTER_KEY = 'payment_status';
export const CUSTOMER_ID_FILTER_KEY = 'customer_id';
export const CUSTOMER_NAME_FILTER_KEY = 'customer_name';
export const USER_ID_FILTER_KEY = 'user_id';
export const USER_NAME_FILTER_KEY = 'user_name';
